var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"iconfont icon-wxbsousuotuiguang",on:{"click":_vm.goSearch}},[_vm._v("搜索一下")])])}
var staticRenderFns = []

export { render, staticRenderFns }